/**
 * Region
 * @author ftgibran
 */

export enum Region {
  CENTRO_OESTE = 'CENTRO_OESTE',
  NORDESTE = 'NORDESTE',
  NORTE = 'NORTE',
  SUDESTE = 'SUDESTE',
  SUL = 'SUL',
}
